import React from 'react';
import { Link } from 'react-router-dom';
import './HeroTreatments.css';

const HeroTreatments = () => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="hero-treatments">
            <div className="hero-treatments-bg">
                <div className="hero-overlay"></div>
            </div>
            
            <div className="container">
                <div className="hero-treatments-content">
                    <div className="hero-text">
                        <h1 className="hero-title">
                            Advanced Treatments For<br />Your Condition
                        </h1>
                        <h2 className="hero-subtitle">
                            Comprehensive Regenerative Medicine For Pain, Performance, And Wellness
                        </h2>
                        
                        <div className="hero-cta-group">
                            <Link 
                                onClick={ClickHandler} 
                                className="hero-btn-primary" 
                                to="/contact"
                            >
                                Schedule Your Consultation
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroTreatments;